import moment from "moment";

export function persistUserEmail(email) {
  localStorage.setItem("userEmail", email);
}

export function getLoggedInUserEmail() {
  return localStorage.getItem("userEmail");
}
export const getEmailAndVideoNameFromUrl = (url) => {
  // Split the URL by '/'
  const parts = url.split("/");
  // Get the email address (assuming it's the second-to-last part of the URL)
  const email = parts[parts.length - 2];
  // Get the last part of the URL
  const lastPart = parts[parts.length - 1];
  // Remove the ".mp4" extension if it exists
  const videoName = lastPart?.replace(".mp4", "");
  // Return an object containing the email and video name

  return generateVideoName(email, videoName);
};
export const generateVideoName = (userEmail, videoName) => {
  return `${userEmail}/${videoName}`;
};

export function generateUniqueId() {
  function s4() {
    return Math.round(Math.random() * 10000);
  }
  return s4() + "-" + s4() + "-" + s4() + "-" + s4();
}

export function base64toImage(imageData) {
  return `data:image/jpeg;base64,${imageData}`;
}

export function getFormattedDate(date) {
  if (!date) return "";

  return moment(date).format("DD.MM.YYYY");
}
export function timeTillNow(date) {
  if (!date) return;
  return moment(date).fromNow();
}
export function dateTimeFormatted(date) {
  if (!date) return;
  return moment(date).format("DD.MM.YYYY HH:mm:ss");
}

export function adjustColumnHeightForIpad({ type, isLandscape, onCompare }) {
  if (isLandscape) {
    function getViewPortHeight(pixelsToMinus) {
      const pixelsToRemove = pixelsToMinus || "62px";
      return !onCompare
        ? `calc(54vh - ${pixelsToRemove})`
        : `calc(50vh - ${pixelsToRemove})`;
    }
    const innerHeight = window.innerHeight;
    const padWithTabsHeight = 917;
    const adjustedHeightWithTabs = window.innerHeight - 119 + "px !important";
    if (
      typeof type === "object" &&
      type?.current?.style &&
      innerHeight === padWithTabsHeight
    ) {
      type.current.style["min-height"] = getViewPortHeight();
      type.current.style.height = getViewPortHeight();
    }
    return function adjustHeightForIpad(node) {
      if (node && innerHeight === padWithTabsHeight) {
        type === "video"
          ? node.style.setProperty("height", getViewPortHeight(), "important")
          : node.style.setProperty("height", "97%", "important");
        window.scrollTo(0, 0);
      }
      if (
        node &&
        innerHeight !== padWithTabsHeight &&
        window.innerWidth <= 1366
      ) {
        type === "video"
          ? node.style.setProperty(
              "height",
              getViewPortHeight("52px"),
              "important",
            )
          : node.style.setProperty("height", "97%", "important");
        window.scrollTo(0, 0);
      }
    };
  } else {
    const innerHeight = window.innerHeight;
    const padWithTabsHeight = 917;
    const adjustedHeightWithTabs = window.innerHeight - 119 + "px !important";
    if (
      typeof type === "object" &&
      type?.current?.style &&
      innerHeight === padWithTabsHeight
    ) {
      type.current.style["min-height"] = adjustedHeightWithTabs;
      type.current.style.height = adjustedHeightWithTabs;
    }
    return function adjustHeightForIpad(node) {
      if (node && innerHeight === padWithTabsHeight) {
        type === "video"
          ? node.style.setProperty("height", "calc(100vh - 130px)", "important")
          : node.style.setProperty("height", "99%", "important");
        window.scrollTo(0, 0);
      }
    };
  }
}
export let VIDEO_HEIGHT = window.screen.availHeight;

export function getVideoRatio(height, grace = 0, isNumber = false) {
  if (height) {
    VIDEO_HEIGHT = height;
  }

  const heightLocal = height || VIDEO_HEIGHT;
  const finalWidth = Math.floor((heightLocal * 9) / 16) - grace;
  if (isNumber) {
    return finalWidth;
  }
  return finalWidth + "px";
}

export function getGraphHeight() {
  const graphHeight = getGraphContainerHeight() - 25;
  return Math.floor(graphHeight) + "px";
}

export function getGraphContainerHeight() {
  const { innerHeight } = window;
  const headerHeight = 68;
  const marginEtc = 42;
  const finalHeight = (innerHeight - headerHeight - marginEtc) / 4;
  return Math.floor(finalHeight);
}

export function getSearchedItem({ searchText, listOfObjects }) {
  return listOfObjects?.filter((item) =>
    Object.values(item).some((value) =>
      String(value)?.toLowerCase().includes(searchText),
    ),
  );
}
export function getDatatableWidth() {
  const innerWidth = window?.innerWidth;

  if (innerWidth > 1800) return 1500;

  return innerWidth - 400;
}

export function getFilterArrOnSearch({ searchableFields, data, searchValue }) {
  const filtered = data?.filter((item) =>
    searchableFields.some((field) =>
      item?.[field]
        ?.toString()
        ?.toLowerCase()
        .includes(searchValue?.toLowerCase()),
    ),
  );
  return filtered;
}
